import { Anchor, Box, Flex, Paper, Tabs, Text, Title, createStyles } from "@mantine/core";
import { ResourceTable, useMedplum } from "@medplum/react";
import { useLocation, useParams } from "react-router-dom";
 const useStyles = createStyles((theme) => ({
   text: {
     border: "1px solid #ddd",
     borderRadius: "5px",
     padding: "12px",
     marginTop: "25px",
     overflow: "auto",
     wordWrap: "break-word",
     maxWidth: "100%",

   },
   paper: {
     marginTop: "20px",
     borderRadius: "8px",
     marginLeft: "40px",
     marginRight: "40px",
     padding: "20px",
     background: "'#FFF",
     boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
   },
 }));

export function MedicationDetails(): JSX.Element {
    const location = useLocation();
    const medplum = useMedplum();
    const query = new URLSearchParams(location.search);
    const patientName = query.get("name") as string;
    const { medicationId = '' } = useParams();
    const med:any = medplum.readResource('MedicationRequest', medicationId).read();
        const { classes } = useStyles();

   
    return (
      <Paper className={classes.paper}>
        <Flex justify={"space-between"}>
          <div>
            <Title order={2}>
              {med?.medicationReference?.display.toUpperCase()}
            </Title>
            <p className="mb-6 text-lg text-gray-600">
              To refill this medication, please contact your pharmacy.
            </p>
            <p className="mb-6 text-lg text-gray-600">
              No more refills available at your pharmacy?{" "}
              <Anchor>Renew your prescription</Anchor>
            </p>
          </div>
          <div>
            <Title color="rgba(129, 137, 153, 1)" size={"14px"} weight={500}>
              Patient Name
            </Title>
            <Title size={"18px"} weight={600}>
              {patientName}
            </Title>
          </div>
        </Flex>
        <Box
          pt="12px"
          pl="24px"
          pb="12px"
          pr="24px"
          bg={"rgba(190, 222, 248, 1)"}
          sx={{ borderRadius: "4px" }}
        >
          <Title size="18px" weight={700}>
            Medication
          </Title>
        </Box>
        <Tabs keepMounted={false} defaultValue="first">
          <Tabs.List sx={{ width: "240px" }}>
            <Tabs.Tab value="first"> Medication</Tabs.Tab>
            <Tabs.Tab value="second">FHIR Response</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="first">
            <Box sx={{ marginTop: "20px" }}>
              <ResourceTable value={med} ignoreMissingValues />
            </Box>
          </Tabs.Panel>
          <Tabs.Panel value="second">
            {" "}
            <Text className={classes.text}>
              <pre>{JSON.stringify(med, null, 2)}</pre>
            </Text>
          </Tabs.Panel>
        </Tabs>
      </Paper>
    );
  }